// extracted by mini-css-extract-plugin
export default {"list":"TagsList_list__SzrQ6"};